export const Buffer = require('buffer').Buffer;
